import { render, staticRenderFns } from "./editIntegral.vue?vue&type=template&id=2c5d7e09&scoped=true&"
import script from "./editIntegral.vue?vue&type=script&lang=js&"
export * from "./editIntegral.vue?vue&type=script&lang=js&"
import style0 from "./editIntegral.vue?vue&type=style&index=0&id=2c5d7e09&lang=scss&scoped=true&"
import style1 from "./editIntegral.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d7e09",
  null
  
)

export default component.exports